export default __webpack_public_path__ + "images/W3.569308e.png";